<template>
  <div v-if="blog">
    <v-text-field label="Titel" outlined class="mb-0 pb-0" hide-details v-model="blog.title"></v-text-field>
    <v-divider></v-divider>
    <div>
      <el-tiptap height="600" v-model="blog.content" :extensions="extensions"/>
    </div>
    <v-divider></v-divider>
    <v-text-field label="Meta-Titel" v-model="blog.metatitle" outlined hide-details></v-text-field>
    <v-divider></v-divider>
    <v-textarea label="Meta-Beschreibung" outlined hide-details v-model="blog.metades"></v-textarea>
    <v-divider></v-divider>
    <v-select v-model="blog.autoren" :items="autoren.autoren" item-text="vorname" item-value="mail" chips label="Autoren" multiple item-color="#3498db"></v-select>
    <v-divider></v-divider>
    <v-select v-if="kategorien" v-model="blog.kategorien" :items="kategorien.kategorien" item-text="title" item-value="slug" chips label="Kategorien" multiple></v-select>
    <v-btn block outlined @click="dialog = true" color="#27ae60">Kategorie erstellen</v-btn>
    <v-divider></v-divider>
    <p>{{blog.slug}}</p>
    <v-divider></v-divider>
    <v-btn block outlined @click="save()" color="#2ecc71">Speichern</v-btn>
    <v-snackbar color="#2ecc71" v-model="snackbar">Gespeichert
      <v-btn dark :href="'https://wach.lernzettel.org/' + blog.slug" target="_blank">Ansehen</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Kategorie</v-card-title>
          <v-text-field class="ml-6 mr-6" v-model="title" label="Titel" single-line></v-text-field>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog = false; addCat()">Weiter</v-btn>
            <v-btn color="red darken-1" text @click="dialog = false; title = ''">Schließen</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar2">Bereits belegt.
        <v-btn color="red" text @click="snackbar = false">Schließen</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  CodeBlock,
  Blockquote,
  ListItem,
  BulletList,
  OrderedList,
  TodoItem,
  TodoList,
  TextAlign,
  Indent,
  LineHeight,
  HorizontalRule,
  HardBreak,
  TrailingNode,
  History,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  FormatClear,
  TextColor,
  TextHighlight,
  Preview,
  Fullscreen
} from 'element-tiptap';

import { db } from '../db'
import { fb } from '../db'

var sl = ''

var storageRef = fb.storage().ref();

const blog = db.collection('blog');
const sh = db.collection('shared');
import { mdiPlus} from '@mdi/js'

export default {
  watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          this.$bind('blog', blog.doc(this.$route.params.lernzettel));
          this.$bind('kategorien', blog.doc('kategorien'));
          this.$bind('autoren', sh.doc('autoren'));
          this.$Progress.finish()
          sl = this.$route.params.lernzettel
        }
      }
  },
  methods: {
    save: function() {
      blog.doc(this.$route.params.lernzettel).set(this.blog).then(() => this.snackbar = true);
      blog.doc('sitemap').get().then((sitemap) => {
        var foundIndex = sitemap.data().posts.findIndex(x => x.slug == this.$route.params.lernzettel);
        var update = sitemap.data().posts
        if(typeof this.blog.metades == 'undefined') {
          this.blog.metades = ''
        }
        if(typeof this.blog.summary == 'undefined') {
          this.blog.summary = ''
        }
        if(typeof this.blog.autoren == 'undefined') {
          this.blog.autoren = []
        }
        if(typeof this.blog.kategorien == 'undefined') {
          this.blog.kategorien = []
        }
        update[foundIndex] = {title: this.blog.title, slug: this.blog.slug, summary: this.blog.metades, autoren: this.blog.autoren, kategorien: this.blog.kategorien}
        blog.doc('sitemap').set({posts: update})
        blog.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.blog.slug + ' verändert.'}, {merge: true})
      })
    },
    addCat: function(){
        if(this.kategorien == null){
          this.kategorien = {}
        }
        this.slug = this.toSlug(this.title)
        if(this.kategorien.kategorien == null || typeof this.kategorien.kategorien == 'undefined') {
          this.kategorien.kategorien = []
        }
        if(typeof this.kategorien.kategorien.find(x => x.slug === this.slug) == 'undefined') {
          this.kategorien.kategorien.push({title: this.title, slug: this.slug})
          blog.doc('kategorien').set({ kategorien: this.kategorien.kategorien });
        } else {
          this.title = '';
          this.slug = '';
          this.snackbar2 = true;
        }
    },
    toSlug: function(str){
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        var to   = "aaaaaeeeeeiiiiooooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
      }
  },
  mounted: function(){
    if(this.$route.params.lernzettel !== ''){
      this.$bind('blog', blog.doc(this.$route.params.lernzettel));
      this.$bind('kategorien', blog.doc('kategorien'));
      this.$bind('autoren', sh.doc('autoren'));
      this.$Progress.finish()
      sl = this.$route.params.lernzettel
    }
  },
  data: () => ({
    renderedc: '',
    snackbar: false,
    autoren: {},
    snackbar2: false,
    kategorien: [],
    title: '',
    slug: '',
    dialog: false,
    plus: mdiPlus,
    blog: {},
    extensions: [
      new Doc(),
      new Text(),
      new Paragraph(),
      new Heading({ level: 5 }),
      new Bold({ bubble: true }), // render command-button in bubble menu.
      new Underline(),
      new Italic(),
      new Strike(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new Link(),
      new Image({
        uploadRequest(file) {
          return new Promise((resolve) => {
            var ref = storageRef.child(sl + '/' + file.name);
            ref.put(file).then(() => {
              ref.getDownloadURL().then((url) => {
                resolve(new URL(url));
              })
            })
          })
        }
      }),
      new CodeBlock(),
      new Blockquote(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new TodoItem(),
      new TodoList(),
      new TextAlign(),
      new Indent(),
      new LineHeight(),
      new HorizontalRule(),
      new HardBreak(),
      new TrailingNode(),
      new History(),
      new Table(),
      new TableHeader(),
      new TableCell(),
      new TableRow(),
      new FormatClear(),
      new TextColor(),
      new TextHighlight(),
      new Preview(),
      new Fullscreen()
    ]
  })
}
</script>